import type { ExecutionMode } from '@web/api/types'

const PROVIDER_TITLES: Record<string, string> = {
  claude: 'Claude',
  codex: 'Codex',
  opencode: 'OpenCode',
  puck: 'Puck',
}

/**
 * Human-readable execution names, matching the provider registry: both
 * physical isolation modes are "Oberon Sandbox", provider-hosted modes are
 * "<Provider> Sandbox", and the connected-tools-only mode is "Lightweight".
 */
export function executionTitle(
  mode: ExecutionMode | string | null | undefined,
  provider?: string | null,
): string {
  switch (mode) {
    case 'docker':
    case 'kubernetes':
      return 'Oberon Sandbox'
    case 'tool-restricted':
      return 'Lightweight'
    case 'claude-managed':
      return `${PROVIDER_TITLES[provider ?? 'claude'] ?? 'Claude'} Sandbox`
    default:
      return mode ? String(mode) : 'Environment default'
  }
}

/** True for provider-hosted modes such as claude-managed. */
export const isManagedMode = (mode: string | null | undefined) =>
  typeof mode === 'string' && mode.endsWith('-managed')
